<script setup>
import { onMounted } from 'vue'
import { consent, loadConsent, saveConsent } from '@/lib/consent'

// Cambiar de opinión. El aviso aparece una sola vez —esa es la gracia—, así que
// sin esto quien aceptó no tendría nunca cómo desdecirse, y retirar el permiso
// es parte de darlo.
//
// Vive en la política de privacidad porque es donde alguien llega cuando busca
// justamente esto, y porque ahí el texto ya explica qué hacen las cookies.
//
// El estado es el mismo que mira el aviso de abajo: responder en cualquiera de
// los dos lugares se ve en el otro sin recargar.
onMounted(loadConsent)
</script>

<template>
  <div class="mt-5 rounded-2xl bg-ink/5 p-5">
    <p class="text-sm font-semibold">
      <template v-if="consent === 'granted'">Hoy tienes las cookies de medición aceptadas.</template>
      <template v-else-if="consent === 'denied'">Hoy tienes las cookies de medición rechazadas.</template>
      <template v-else>Todavía no has respondido el aviso de cookies.</template>
    </p>

    <div class="mt-4 flex flex-wrap gap-3">
      <button
        type="button"
        class="rounded-full px-5 py-2.5 text-sm font-semibold ring-1 transition-colors"
        :class="consent === 'denied'
          ? 'bg-ink text-linen ring-ink'
          : 'text-ink ring-ink/25 hover:ring-ink/50'"
        @click="saveConsent('denied')"
      >
        Rechazarlas
      </button>
      <button
        type="button"
        class="rounded-full px-5 py-2.5 text-sm font-semibold ring-1 transition-colors"
        :class="consent === 'granted'
          ? 'bg-ink text-linen ring-ink'
          : 'text-ink ring-ink/25 hover:ring-ink/50'"
        @click="saveConsent('granted')"
      >
        Aceptarlas
      </button>
    </div>

    <p class="mt-3 text-sm text-ink-soft">
      El cambio vale desde ya y se recuerda en este navegador. Rechazarlas no
      afecta en nada tu cotización.
    </p>
  </div>
</template>
